import { useEffect } from 'react';

import { useIntersectionObserver, UseIntersectionObserverArgs } from './useIntersectionObserver';

const DEFAULT_DELAY_IN_MS = 100;

interface UseInfiniteScrollArgs extends UseIntersectionObserverArgs {
	delayInMs?: number;
	hasNextPage: boolean | undefined;
	isDisabled?: boolean;
	isLoading: boolean;
	onLoadMore: VoidFunction;
}

export const useInfiniteScroll = ({
	delayInMs = DEFAULT_DELAY_IN_MS,
	hasNextPage,
	isDisabled = false,
	isLoading,
	onLoadMore,
	rootMargin,
	threshold,
}: UseInfiniteScrollArgs) => {
	const { isIntersecting, rootRef, targetRef } = useIntersectionObserver({
		rootMargin,
		threshold,
	});

	const shouldLoadMore = hasNextPage && !isDisabled && isIntersecting && !isLoading;

	useEffect(() => {
		if (shouldLoadMore) {
			const timer = setTimeout(() => {
				onLoadMore();
			}, delayInMs);

			return () => clearTimeout(timer);
		}
	}, [delayInMs, onLoadMore, shouldLoadMore]);

	return {
		loadMoreRef: targetRef,
		rootRef,
	};
};
